/**
 * System source labels from backend Labels.cs shown on Finanzas summary.
 * Exact match only — typed employer / other-income names stay protected.
 */
const TRANSLATABLE_INCOME_SOURCES = new Set([
  "Pension",
  "Social Security",
  "Military",
  "Alimony",
  "Child Support",
  "Separate Maintenance",
  "Other Income",
]);

const TRANSLATABLE_ASSET_SOURCES = new Set([
  "Gift",
  "Other Asset",
  "Purchase Deposit",
  "Proceeds",
]);

export const isTranslatableIncomeSource = (source: string | null | undefined): boolean => {
  const trimmed = source?.trim() ?? "";
  return trimmed ? TRANSLATABLE_INCOME_SOURCES.has(trimmed) : false;
};

export const isTranslatableAssetSource = (source: string | null | undefined): boolean => {
  const trimmed = source?.trim() ?? "";
  return trimmed ? TRANSLATABLE_ASSET_SOURCES.has(trimmed) : false;
};

/** Protect typed names; unlock known system labels for GlobalLink. */
export const shouldProtectFinancesSummarySource = (
  source: string | null | undefined,
  kind: "income" | "asset"
): boolean =>
  kind === "income"
    ? !isTranslatableIncomeSource(source)
    : !isTranslatableAssetSource(source);
